<h5 mat-dialog-title *ngIf="data.serviceType == null">
  Reserva {{ data.reservaId }}
</h5>
<h5 mat-dialog-title *ngIf="data.serviceType == 10">
  Itinerary {{ data.fileName }}
</h5>
<h5 mat-dialog-title *ngIf="data.serviceType !== null">
  {{ data.serviceName }}
</h5>

<mat-dialog-content class="" style="min-height: 210px; max-height: 730px">
  <div
    *ngIf="isLoading; else showContent"
    class="spinner div-center div-vertical-center column-base"
    style="gap: 20px"
  >
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    <span class="loader-text"> Buscando documentos... </span>
  </div>

  <ng-template #showContent>
    <div class="column-base div-center" style="gap: 20px; width: 100%">
      <div
        style="width: 100%"
        *ngFor="let multimedia of multimedia; let i = index"
      >
        <div
          style="
            width: 100%;
            border: solid;
            border-color: rgba(0, 0, 0, 0.12);
            border-width: 1px;
            border-radius: 4px;
            align-items: center;
            padding: 12px 19px;
          "
          [style.background-color]="
            multimedia.isTicketDateMismatch ? '#ffebee' : 'white'
          "
          *ngIf="!pdfViewer || index === i"
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div class="multimedia-name">{{ multimedia.name }}</div>

            <div style="display: flex; justify-content: center; gap: 10px">
              <button
                mat-icon-button
                class=".icon-Active"
                (click)="activatePDF(multimedia, i)"
              >
                <i-tabler name="eye"></i-tabler>
              </button>
              <button
                mat-icon-button
                class=".icon-Active"
                (click)="deleteMultimedia(multimedia, i)"
              >
                <i-tabler name="trash"></i-tabler>
              </button>
              <button
                mat-icon-button
                class=".icon-Active"
                (click)="downloadFile(multimedia)"
              >
                <i-tabler name="download"></i-tabler>
              </button>
            </div>
          </div>

          <div
            style="
              display: flex;
              justify-content: center;
              background-color: #d9d9d9;
            "
            *ngIf="pdfViewer && index == i"
          >
            <iframe [src]="url" width="100%" height="600px"> </iframe>
          </div>
        </div>
      </div>

      <div
        style="
          height: 48px;
          font-size: 16px;
          line-height: 140%;
          letter-spacing: -2%;
          text-align: center;
          color: #303030;
        "
        *ngIf="multimedia.length === 0"
        class="div-vertical-center div-center"
      >
        No hay documentos cargados.
      </div>

      <hr
        style="width: 800px; border-color: rgba(0, 0, 0, 0.12) !important"
        *ngIf="!pdfViewer"
      />

      <input
        style="display: none"
        type="file"
        accept=".pdf,.doc,.docx,.xls,.xlsx,image/jpeg,image/png"
        multiple
        (change)="onFileSelected($event)"
        #fileUpload
      />

      <div
        style="width: 600px; gap: 20px"
        class="column-base"
        *ngIf="!pdfViewer"
      >
        <button
          *ngIf="data.serviceType !== 10"
          mat-raised-button
          class="buttonPrimary row-base div-center div-vertical-center white-spinner"
          style="
            gap: 4px;
            width: 100%;
            box-shadow: none !important;
            min-height: 36px;
          "
          (click)="fileUpload.click()"
        >
          <i-tabler
            *ngIf="!uploading"
            name="file-upload"
            style="color: #ffffff !important; box-shadow: none !important"
          ></i-tabler>
          <span *ngIf="!uploading">Cargar Documento</span>

          <mat-spinner *ngIf="uploading" [diameter]="20"></mat-spinner>
        </button>
        <p class="nota-usuario">
          <strong>Nota:</strong> Solo se podrán visualizar archivos peso menor a
          <strong>1.5 MB </strong>, en formato <strong>.pdf</strong> e
          <strong>imágenes</strong>. Si el archivo no es compatible, se
          descargará automáticamente al intentar abrirlo.
        </p>
      </div>
    </div>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions class="div-end">
  <button mat-flat-button (click)="onCancel()" class="close-btn">Cerrar</button>
</mat-dialog-actions>
